import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { debugNavigation } from './debug-navigation'

import VueGoogleMaps from '@fawmi/vue-google-maps'

// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';


// スタイルのインポート
import './styles/global.scss'
import './assets/scss/custom.scss'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHatWizard } from '@fortawesome/free-solid-svg-icons'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Google Analytics
import gtag from './plugins/gtag'


library.add(faHatWizard)


import { createPinia } from 'pinia'

const app = createApp(App);
const pinia = createPinia();

app.use(router)
.use(pinia)
.use(debugNavigation)
.use(gtag, router) // GA4を追加
.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBxLXIlnhEEwhwJP9f6jwH-rssaCBFFrcg',
    },
})
.component('font-awesome-icon', FontAwesomeIcon)
.use(VueAxios, axios)
.mount('#app');

